var exports = {
  "az": "Box__TjWcZo",
  "wy": "Box_1__3EslmP",
  "pv": "Box_2__ou_-75",
  "EY": "Text__0krGSG",
  "UE": "Text_1__kpeRD1",
};

module.exports = exports;
